import { FC } from 'react'
import { IUserReferenceBase } from '../../../types'
import { getUserAvatar, sanitizeUrl } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import { VerifiedName } from '../../atoms/VerifiedName'
import { CommentCard } from '../../organisms/CommentCard'

type Props = {
  item: IUserReferenceBase
  onClickEdit?: (reference: IUserReferenceBase) => void
  onClickDelete?: (id: string) => void
  isTwoColum?: boolean
  haveEditAndDelete?: boolean
}

export const UserReferenceCard: FC<Props> = ({
  item,
  onClickEdit,
  onClickDelete,
  isTwoColum = false,
  haveEditAndDelete = false,
}) => {
  return (
    <CommentCard
      comment={item.comment}
      href={sanitizeUrl(`/users/${item.commenter?.username}`)}
      renderLogo={() => <Avatar src={getUserAvatar(item.commenter)} alt={item.commenter?.name} />}
      renderName={() => (
        <VerifiedName name={item.commenter?.name} isVerifiedAccount={item.commenter?.profile.isVerifiedAccount} />
      )}
      onClickEdit={() => onClickEdit(item)}
      onClickDelete={() => onClickDelete(item.id)}
      isTwoColumn={isTwoColum}
      haveEditAndDelete={haveEditAndDelete}
    />
  )
}
